import React, { Component } from "react";
import { connect } from "react-redux";

import {
  loadImmeubles,
  saveImmeuble,
  updateImmeuble,
  deleteImmeuble,
} from "../../store/actions/immeubleAction";

import SelectImmeuble from "../../components/SelectImmeuble";
import { loadLots } from "../../store/actions/lotAction";

import { toast } from "react-toastify";

class Immeubles extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    this.props.loadImmeubles();
    this.props.loadLots();
  }

  handleSubmitImmeuble = (data) => {
    this.props
      .saveImmeuble(data)
      .then((res) => {
        toast.success("Immeuble créé !", { containerId: "A" });
      })
      .catch((err) => {
        toast.error("Échec de la création !", { containerId: "A" });
      });
  };

  handleEditImmeuble = (data, id) => {
    this.props
      .updateImmeuble(data, id)
      .then((res) => {
        toast.success("Immeuble édité !", { containerId: "A" });
      })
      .catch((err) => {
        toast.error("Échec de l'édition !", { containerId: "A" });
      });
  };

  handleDeleteImmeuble = (id) => {
    this.props
      .deleteImmeuble(id)
      .then((res) => {
        toast.success("Immeuble supprimé !", { containerId: "A" });
      })
      .catch((err) => {
        toast.error("Suppression impossible : il existe des lots rattachés à cet immeuble.", { containerId: "A" });
      });
  };

  render() {
    const { immeubles, utilisateur, immeubleProps, lots } = this.props;

    immeubles && immeubles.sort((a, b) => {
      return a.immeuble_id - b.immeuble_id;
    });

    return (
      <div>
        {immeubles && (
          <SelectImmeuble
            immeubleProps={immeubleProps}
            utilisateur={utilisateur}
            listData={immeubles}
            handleSubmitImmeuble={this.handleSubmitImmeuble}
            handleEditImmeuble={this.handleEditImmeuble}
            handleDeleteImmeuble={this.handleDeleteImmeuble}
            lots={lots}
            addPanesLot={this.props.addPanesLot}
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadImmeubles: () => dispatch(loadImmeubles()),
    saveImmeuble: (jsonData) => dispatch(saveImmeuble(jsonData)),
    updateImmeuble: (jsonData, id) => dispatch(updateImmeuble(jsonData, id)),
    deleteImmeuble: (id) => dispatch(deleteImmeuble(id)),
    loadLots: () => dispatch(loadLots()),
  };
};

// mapper le state aux props du component
const mapStateToProps = (state) => {
  return {
    immeubles: state.immeubles.data,
    utilisateur: state.utilisateur.data,
    lots: state.lots.data,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Immeubles);
